/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * Page: No Subscription.
 */

import React, { useEffect } from "react";
import {useAuth0} from "@auth0/auth0-react";
import { PageLayout } from "../components/PageLayout";
import { PageLoader } from "../components/PageLoader";
import { logoutToShop } from "../utils/subscriptionGate";

/**
 * Legacy/deep-link landing for users without a paid tier.
 * Shows a short message, then ends the Auth0 session and sends them to the shop.
 */
export const NoSubscription = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    const timer = setTimeout(() => {
      logoutToShop(logout);
    }, 2000);
    return () => clearTimeout(timer);
  }, [logout]);

  return (
    <PageLayout>
      <div style={{ textAlign: "center", padding: "3rem 1rem" }}>
        <h2>No subscription found</h2>
        <p>Redirecting you to sign up…</p>
        <PageLoader />
      </div>
    </PageLayout>
  );
};

export default NoSubscription;
